// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1HVST","info":"UpdateTermsInfo_info__34G8D"};